var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-box"},[_c('div',{staticClass:"content"},[(_vm.active === 0)?_c('step-account',{on:{"sendActive":_vm.setActive,"updateInfo":_vm.updateMember,"logInfo":_vm.logInfo}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }